import {
  FetchSearchResultsRequest,
  FetchSearchResultsSuccess,
  FetchSearchResultsFailure,
} from './search-results.actions'
import { SearchResultsService } from './search-results.service'
import { ShowSnackbar } from './../../shared/shared.actions'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import * as SearchTypes from './search-results.types'
import { map, switchMap, tap, catchError } from 'rxjs/operators'
import { Router } from '@angular/router'

@Injectable()
export class SearchResultsEffects {
  constructor(
    private actions: Actions,
    private searchService: SearchResultsService,
  ) {}

  FetchSearchResults$ = createEffect(() =>
    this.actions.pipe(
      ofType(SearchTypes.FETCH_SEARCH_RESULTS_REQUEST),
      switchMap((action: FetchSearchResultsRequest) => {
        return this.searchService.fetchSearchResults(action.params).pipe(
          map((result) => {
            return new FetchSearchResultsSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchSearchResultsFailure({ error: err }))
          }),
        )
      }),
    ),
  )
}
